import { render, staticRenderFns } from "./onDevelopment.vue?vue&type=template&id=5d1c9aff&"
import script from "./onDevelopment.vue?vue&type=script&lang=js&"
export * from "./onDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./onDevelopment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports